import { useDispatch } from 'react-redux';
import { exportTemplateActions } from 'reducers/exportTemplate/reducer';
import { useGet } from 'hooks';
import { exportTemplatesMetadata } from 'services/api';

/**
 * Hook to fetch the sheet metadata for the export templates.
 * @returns {Object} metadataRes - The response from the API call.
 */
export const useTemplateMetadataFetch = () => {
  const dispatch = useDispatch();
  const [metadataRes] = useGet({
    url: exportTemplatesMetadata,
    onMount: true,
    configuration: {
      onRequestSuccess: httpData => {
        dispatch(exportTemplateActions.sheetMetadataReceived(httpData));
      },
    },
  });
  return metadataRes;
};
